import Enums from "../model/enums";

export const getConditionalWagesFieldName = (year) => {
  return year >= "2022" ? "totalW2Box1" : "wagesSalaries"
}

export default { getConditionalWagesFieldName }
